import React, { useState, useRef, useEffect, useContext } from "react";
import { pdfUpload, setPortoModuleComplete, setinputMetaDataFlag, setinputMetaData, addImageToList, saveInputMetaData, getWebpImageFormat, getImgQualityFactor, saveClaimReason, userLogs, patLogs, } from "../context/utils";
import { AppContext } from "../context";
import Rotate from "./Rotate";
import cameraImg from "../img/camera.png";
import Button from "./Button";
import white_tick from "../img/white_tick.png";
import { get } from "underscore";
import { startVideoPlayback } from "../utils_new/videoPlayback";
import SafeImage from "./SafeImage";
const MAX_LIMIT = 5;
let logBugs = true;
let image = null;

const NewDocumentUpload = () => {
    const {
        stepCovered,
        setScreen,
        setLandscape,
        config,
        setCurrentPage,
        inspectionId,
        mandatory,
        setMandatory,
        isLandscape,
        setCondition,
        currentBlock,
        condition,
        clientId,
        setStepCovered,
        docs,
        setDocs,
        showErrorPopup,
        setShowErrorPopup,
        popupContent,
        setPopupContent,
        previewItem,
        setPreviewItem,
        isCameraOpen,
        setIsCameraOpen,
        activeDocId,
        setActiveDocId,
        stream,
        setStream,
        isFormValid,
        setIsFormValid,
        inputMetaData
    } = useContext(AppContext);

    const documentCategories = [
        { id: "claimForm", label: "Upload Claim Form", InnerLabel: "Upload or capture your claim form", type: "upload", required: false, link: "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/client-icon%26logo/RC.png" },
        { id: "claimReason", label: "Enter Cause of Incident", InnerLabel: "", type: "text", required: false, link: "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/document_writing_icon.png" }
    ];

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [submittedCategories, setSubmittedCategories] = useState({});

    // NEW STATE: Tracks whether files came from 'camera' or 'upload' picker
    const [docSource, setDocSource] = useState({
        rc: null,
        claimForm: null,
        dl: null,
        estimateCopy: null,
    });

    const getTranslateText = (text) => {
        if (Object.keys(config["language"]).includes(text)) {
            return config["language"][text];
        } else {
            // const data = translateText(text, config["language"]["langCode"]);
            return text;
        }
    };

    // Tracks text field values
    const [textDocs, setTextDocs] = useState({});

    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const rotatePage = useRef(null);

    if (logBugs) {
        patLogs(`Entered to ${currentBlock.tag}`, inspectionId);
        userLogs({
            position: 8,
            last_page: `${currentBlock.tag} Module`,
            inspectionId,
        });
    }
    logBugs = false;

    useEffect(() => { }, []);

    const land = () => window.innerWidth > window.innerHeight * 1.2;
    window.onresize = () => {
        if (!land()) {
            rotatePage.current.style.display = "flex";
        } else {
            rotatePage.current.style.display = "none";
        }
        setLandscape(land());
    };

    useEffect(() => {
        const allRequiredFilled = documentCategories
            .filter((cat) => cat.required)
            .every((cat) => submittedCategories[cat.id] === true);
        setIsFormValid(allRequiredFilled);
    }, [submittedCategories, documentCategories]);

    const triggerWarning = (title, message) => {
        setPopupContent({ title, message });
        setShowErrorPopup(true);
    };

    const handleMainClick = () => {
        if (!isFormValid) {
            triggerWarning(
                "Missing Documents",
                "Please upload all mandatory documents (*) before proceeding.",
            );
        } else {
            Object.keys(docs).forEach((key) => {
                if (Array.isArray(docs[key]) && docs[key].length > 0) {
                    docs[key].forEach((item, index) => {
                        let d = {};
                        let counter = index + 1;

                        if (item.startsWith("data:application/pdf")) {
                            d["pdfData"] = item;
                            pdfUpload(clientId, inspectionId, d, `${key}_${counter}`);
                        } else {
                            d["imgData"] = item;
                            let region = Object.keys(config["video-page"]).includes("clientRegion")
                                ? config["video-page"]["clientRegion"]
                                : "eu-central-1";
                            image = {
                                name: `${key}-${index}.jpg`,
                                imgData: item,
                                tag: `${currentBlock.tag}_${index}`,
                                web_region: null,
                                angle: null,
                                region: region,
                                env: 1,
                                videoData: null,
                                dialStatus: null,
                                currentTag: `${key}-${index}`,
                                currentBlockName: currentBlock["id"],
                                currentSubBlock: `${key}-${index}`,
                                overlayStencil: false
                            };
                            addImageToList(image);
                            //pdfUpload(clientId, inspectionId, d, `${key}_${counter}`);
                        }
                    });
                }
                else if (typeof docs[key] === "string" && Object.keys(textDocs).length > 0) {
                    let text = textDocs[key]?.trim();
                    if (text.length > 0) {
                        const tempInputMetaData = inputMetaData ? { ...inputMetaData } : {};
                        tempInputMetaData[key] = text;
                        setinputMetaData(tempInputMetaData);
                        saveClaimReason(inspectionId, text);
                        saveInputMetaData();
                    }
                }
            });
            patLogs(`claim Images uploaded are: ${docs?.claimForm.length} and claim reason submitted is: ${Object.keys(textDocs).length > 0 ? textDocs?.claimReason : "{}"}`, inspectionId);
            // console.log("Final Base64 Data:", docs);
            // console.log("Final Text Data:", textDocs);
            if (currentBlock["mandatory"]) {
                let temp1 = mandatory;
                temp1[currentBlock["id"]] = "completed";
                setMandatory(temp1);
            }
            let temp = condition;
            temp[currentBlock["id"]] = "completed";
            setCondition(temp);
            setPortoModuleComplete(currentBlock["tag"]);
            patLogs(`${currentBlock.id} is completed`, inspectionId);
            setScreen("menu");
        }
    };


    const startCamera = async (id) => {
        // Check Source State
        if (docSource[id] === "upload") {
            triggerWarning(
                "Action Blocked",
                "You have already uploaded files. Please remove them to use the camera.",
            );
            return;
        }
        if (docs[id].length >= MAX_LIMIT) {
            triggerWarning(
                "Limit Reached",
                `You can only capture a maximum of ${MAX_LIMIT} items.`,
            );
            return;
        }
        setActiveDocId(id);
        setIsCameraOpen(true);
        try {
            const mediaStream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "environment", width: 1280, height: 720 },
                audio: false,
            });
            setStream(mediaStream);
            if (videoRef.current) videoRef.current.srcObject = mediaStream;
            startVideoPlayback(videoRef.current, config);
        } catch (err) {
            setIsCameraOpen(false);
        }
    };

    const handlePdfUpload = (e, id) => {
        // Check Source State
        if (docSource[id] === "camera") {
            triggerWarning(
                "Action Blocked",
                "You have already captured images. Please remove them to upload files.",
            );
            e.target.value = null;
            return;
        }

        const files = Array.from(e.target.files);
        if (docs[id].length + files.length > MAX_LIMIT) {
            triggerWarning(
                "Limit Reached",
                `Total files cannot exceed ${MAX_LIMIT}.`,
            );
            e.target.value = null;
            return;
        }

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setDocs((prev) => ({
                    ...prev,
                    [id]: [...prev[id], base64String],
                }));
                // Lock the source to 'upload'
                setDocSource((prevSource) => ({ ...prevSource, [id]: "upload" }));
            };
            reader.readAsDataURL(file);
        });
        e.target.value = null;
    };

    const takePhoto = () => {
        if (docs[activeDocId].length >= MAX_LIMIT) {
            stopCamera();
            triggerWarning("Limit Reached", "Maximum limit reached.");
            return;
        }
        const video = videoRef.current;
        const canvas = canvasRef.current;
        if (video && canvas) {
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            canvas.getContext("2d").drawImage(video, 0, 0);
            const imageData = getWebpImageFormat() && !isIOS
                ? canvas.toDataURL("image/webp", getImgQualityFactor())
                : canvas.toDataURL("image/jpeg");
            //const imageData = canvas.toDataURL("image/jpeg", 0.8);

            setDocs((prev) => ({
                ...prev,
                [activeDocId]: [...prev[activeDocId], imageData],
            }));
            // Lock the source to 'camera'
            setDocSource((prevSource) => ({
                ...prevSource,
                [activeDocId]: "camera",
            }));
        }
    };

    const stopCamera = () => {
        if (stream) stream.getTracks().forEach((track) => track.stop());
        setStream(null);
        setIsCameraOpen(false);
    };

    const removeFile = (docId, index) => {
        // If we are removing the very last file, unlock the source
        if (docs[docId].length === 1) {
            setDocSource((prevSource) => ({ ...prevSource, [docId]: null }));
        }

        setDocs((prev) => {
            const newList = [...prev[docId]];
            newList.splice(index, 1);
            return { ...prev, [docId]: newList };
        });
        setPreviewItem(null);
    };

    const backBtn = () => {
        patLogs("back button clicked", inspectionId);
        if (["opes_prod", "opes_uat"].includes(clientId)) {
            setScreen("menuOpes");
        } else {
            setScreen("menu");
        }
    };

    return (
        <div style={{ position: "relative", height: "100dvh", width: "100dvw" }}>
            <>
                <div
                    className="rotatePage"
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        zIndex: 999999,
                        width: "100dvw",
                        height: "100dvh",
                        backgroundColor: "#fff",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    ref={rotatePage}
                >
                    <Rotate />
                </div>
                <div style={styles.appWrapper}>
                    {previewItem && (
                        <div style={styles.previewOverlay}>
                            <div style={styles.previewContent}>
                                {previewItem.data.includes("image/") ? (
                                    <img
                                        src={previewItem.data}
                                        style={styles.fullImage}
                                        alt="Preview"
                                    />
                                ) : (
                                    <div style={styles.pdfPreviewCard}>
                                        <h4 style={{ margin: "10px 0", color: "#007bff" }}>
                                            PDF Document
                                        </h4>
                                        <div style={styles.pdfBadge}>PDF Ready</div>
                                    </div>
                                )}
                            </div>
                            <div style={styles.previewBottomNav}>
                                <button
                                    style={styles.previewBackBtn}
                                    onClick={() => setPreviewItem(null)}
                                >
                                    Back
                                </button>
                                <button
                                    style={styles.previewRemoveBtn}
                                    onClick={() => removeFile(previewItem.id, previewItem.index)}
                                >
                                    Remove
                                </button>
                            </div>
                        </div>
                    )}

                    {showErrorPopup && (
                        <div
                            style={styles.popupOverlay}
                            onClick={() => setShowErrorPopup(false)}
                        >
                            <div style={styles.popupBox} onClick={(e) => e.stopPropagation()}>
                                <h3 style={{ margin: "10px 0", color: "#007bff" }}>
                                    {popupContent.title}
                                </h3>
                                <p style={{ color: "#666", fontSize: "14px" }}>
                                    {popupContent.message}
                                </p>
                                <button
                                    style={styles.closePopupButton}
                                    onClick={() => setShowErrorPopup(false)}
                                >
                                    Got it
                                </button>
                            </div>
                        </div>
                    )}

                    {isCameraOpen && (
                        <div style={styles.cameraFull}>
                            <video
                                ref={videoRef}
                                autoPlay
                                playsInline
                                style={styles.videoStream}
                            />
                            <canvas ref={canvasRef} style={{ display: "none" }} />
                            <div style={styles.camControls}>
                                <div style={styles.countBadge}>
                                    {docs[activeDocId]?.length} / {MAX_LIMIT}
                                </div>
                                <div style={styles.shutterBtn} onClick={takePhoto}></div>
                                <button onClick={stopCamera} style={styles.doneBtn}>
                                    Done
                                </button>
                            </div>
                        </div>
                    )}

                    <div style={styles.mainContent}>
                        <h2 style={styles.mainTitle}>{selectedCategory ? selectedCategory.label : getTranslateText("Please choose one option to continue")}</h2>

                        {!selectedCategory ? (
                            <>
                                <div style={styles.optionsContainer}>
                                    {documentCategories.map((doc) => {
                                        const isCompleted = submittedCategories[doc.id] === true;

                                        return (
                                            <div key={doc.id} className="menu-options" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                {doc.required ? (
                                                    <h4 style={isCompleted ? { margin: "0px 0px 10px 0px", textAlign: "center", color: (config?.colors?.["complete-block"] || "#06BA41") } : { margin: "0px 0px 10px 0px", textAlign: "center" }}>
                                                        {getTranslateText(doc.label)}&#42;
                                                    </h4>
                                                ) : (
                                                    <h4 style={isCompleted ? { margin: "0px 0px 10px 0px", textAlign: "center", color: (config?.colors?.["complete-block"] || "#06BA41") } : { margin: "0px 0px 10px 0px", textAlign: "center" }}>
                                                        {getTranslateText(doc.label)}
                                                    </h4>
                                                )}
                                                <div className="process-vin" style={{ border: isCompleted ? `2px solid ${config?.colors?.["complete-block"] || "#06BA41"}` : `1px solid ${config?.colors?.["incomplete-block"] || "#d1d1d1"}` }} onClick={() => {
                                                    if (!isCompleted) setSelectedCategory(doc);
                                                }}>
                                                    {isCompleted && (
                                                        <div className="greenCircleTick">
                                                            <img src={white_tick} alt="tick" />
                                                        </div>
                                                    )}
                                                    {currentBlock && currentBlock["link"] && (
                                                        <SafeImage src={doc["link"]} alt="icon" />
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div style={{ ...styles.bottomNavContainer, backgroundColor: "#F8F7FC" }}>
                                    <div style={styles.bottomNavInner}>
                                        <Button
                                            secoundaryBtn="true"
                                            text="Go back"
                                            onclick={backBtn}
                                            marginDefault="0px 0px 0px 0px"
                                        />
                                        <Button
                                            text="Submit"
                                            disabled={!isFormValid}
                                            onclick={handleMainClick}
                                            marginDefault="0px 25px 0px 25px"
                                        />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div style={styles.stackContainer}>
                                    {[selectedCategory].map((doc) => {
                                        const source = docSource[doc.id];
                                        const isCamDisabled = source === "upload";
                                        const isUploadDisabled = source === "camera";
                                        const isText = doc.type === "text";

                                        return (
                                            <div key={doc.id} style={styles.fullWidthCard}>
                                                <div style={styles.cardInfo}>
                                                    <div style={styles.cardLabel}>
                                                        {getTranslateText(doc.InnerLabel)}{" "}
                                                        {doc.required && (
                                                            <span style={{ color: "red" }}>*</span>
                                                        )}
                                                    </div>
                                                    {!isText && (
                                                        <div style={styles.btnGroup}>
                                                            <button
                                                                onClick={() => startCamera(doc.id)}
                                                                style={{
                                                                    ...styles.camAction,
                                                                    opacity: isCamDisabled ? 0.4 : 1,
                                                                }}
                                                            >
                                                                {getTranslateText("Click Photo")}
                                                            </button>
                                                            <div
                                                                onClick={() =>
                                                                    isUploadDisabled &&
                                                                    triggerWarning(
                                                                        "Action Blocked",
                                                                        "Remove captured images to enable file upload.",
                                                                    )
                                                                }
                                                            >
                                                                <label
                                                                    style={{
                                                                        ...styles.pdfAction,
                                                                        opacity: isUploadDisabled ? 0.4 : 1,
                                                                    }}
                                                                >
                                                                    {getTranslateText("Upload File")}
                                                                    <input
                                                                        type="file"
                                                                        accept=".pdf, image/*"
                                                                        multiple
                                                                        disabled={isUploadDisabled}
                                                                        onChange={(e) => handlePdfUpload(e, doc.id)}
                                                                        hidden
                                                                    />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                {isText ? (
                                                    <div style={{ marginTop: "15px" }}>
                                                        <textarea
                                                            style={styles.textAreaField}
                                                            placeholder={getTranslateText("Please enter here")}
                                                            value={textDocs[doc.id] || ""}
                                                            onChange={(e) => setTextDocs(prev => ({ ...prev, [doc.id]: e.target.value }))}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div style={styles.previewScroll}>
                                                        {docs[doc.id] && docs[doc.id].length > 0 ? (
                                                            docs[doc.id].map((base64, i) => (
                                                                <div
                                                                    key={i}
                                                                    style={styles.previewItem}
                                                                    onClick={() =>
                                                                        setPreviewItem({
                                                                            data: base64,
                                                                            id: doc.id,
                                                                            index: i,
                                                                        })
                                                                    }
                                                                >
                                                                    {base64.includes("image/") ? (
                                                                        <img
                                                                            src={base64}
                                                                            style={styles.imgFill}
                                                                            alt="snap"
                                                                        />
                                                                    ) : (
                                                                        <div style={styles.pdfText}>PDF</div>
                                                                    )}
                                                                    <div
                                                                        style={styles.delBtn}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            removeFile(doc.id, i);
                                                                        }}
                                                                    >
                                                                        ×
                                                                    </div>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div style={styles.emptyMessage}>
                                                                {/* {doc.required ? "Mandatory" : "Optional"} */}
                                                                {getTranslateText("You can upload multiple photos or files")}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div style={{ ...styles.bottomNavContainer, backgroundColor: "#F8F7FC" }}>
                                    <div style={styles.bottomNavInner}>
                                        <Button
                                            secoundaryBtn="true"
                                            text="Go back"
                                            onclick={() => setSelectedCategory(null)}
                                            marginDefault="0px 0px 0px 0px"
                                        />
                                        <Button
                                            text="Submit"
                                            onclick={() => {
                                                const hasContent = selectedCategory.type === "text"
                                                    ? (textDocs[selectedCategory.id] && textDocs[selectedCategory.id].trim().length > 0)
                                                    : (docs[selectedCategory.id] && docs[selectedCategory.id].length > 0);
                                                if (hasContent) {
                                                    setSubmittedCategories(prev => ({ ...prev, [selectedCategory.id]: true }));
                                                }
                                                setSelectedCategory(null);
                                            }}
                                            marginDefault="0px 25px 0px 25px"
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </>
        </div>
    );
};

const styles = {
    appWrapper: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#fff",
        overflowX: "hidden",
    },
    mainContent: { padding: "20px", maxWidth: "800px", margin: "0 auto" },
    optionsContainer: {
        display: "flex",
        gap: "30px",
        overflowX: "auto",
        padding: "45px 10px 10px 10px",
        justifyContent: "center",
        alignItems: "center"
    },
    optionCard: {
    },
    optionStatus: {
        fontSize: "16px",
        fontWeight: "bold"
    },
    bottomNavContainer: {
        display: "flex",
        backgroundColor: "#F8F7FC",
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        padding: "15px 0",
        zIndex: 100
    },
    bottomNavInner: {
        display: "flex",
        justifyContent: "flex-end",
        alignContent: "center",
        width: "100%",
    },
    btnSecondary: {
        backgroundColor: "#fff",
        color: "#333",
        border: "1px solid #333",
        padding: "10px 24px",
        borderRadius: "4px",
        fontSize: "16px",
        fontWeight: "bold",
        cursor: "pointer",
        margin: "0px 0px 0px 0px"
    },
    btnPrimary: {
        backgroundColor: "#007bff",
        color: "#fff",
        border: "1px solid #007bff",
        padding: "10px 24px",
        borderRadius: "4px",
        fontSize: "16px",
        fontWeight: "bold",
        cursor: "pointer",
        margin: "0px 25px 0px 25px"
    },
    btnPrimaryDisabled: {
        backgroundColor: "#d0d0d0",
        color: "#fff",
        border: "1px solid #d0d0d0",
        padding: "10px 24px",
        borderRadius: "4px",
        fontSize: "16px",
        fontWeight: "bold",
        cursor: "not-allowed",
        margin: "0px 25px 0px 25px"
    },
    mainTitle: {
        margin: "15px 0px 6px 0px",
        textAlign: "center",
        color: "black",
    },
    stackContainer: { display: "flex", flexDirection: "column", gap: "14px", padding: "35px 0px 10px 0px" },
    fullWidthCard: {
        background: "#fff",
        borderRadius: "12px",
        padding: "15px",
        border: "1px solid #eef2f7",
        boxShadow: "0 2px 6px rgba(0,0,0,0.02)",
    },
    cardInfo: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px",
    },
    cardLabel: { fontWeight: "700", fontSize: "15px", color: "#333" },
    btnGroup: { display: "flex", gap: "8px", alignItems: "center" },
    camAction: {
        padding: "10px 20px",
        border: "none",
        borderRadius: "8px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#007bff",
        color: "#fff",
        cursor: "pointer",
    },
    pdfAction: {
        padding: "3px 31px",
        borderRadius: "8px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#fff",
        color: "#007bff",
        border: "2px solid #007bff",
        cursor: "pointer",
        display: "inline-block",
    },
    previewScroll: {
        display: "flex",
        gap: "12px",
        marginTop: "15px",
        overflowX: "auto",
        paddingTop: "10px",
        borderTop: "1px solid #f2f2f2",
        minHeight: "60px",
        alignItems: "center",
    },
    previewItem: {
        position: "relative",
        width: "70px",
        height: "55px",
        flexShrink: 0,
    },
    imgFill: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: "6px",
        border: "1px solid #007bff",
    },
    pdfText: {
        width: "100%",
        height: "100%",
        background: "#fff",
        color: "#007bff",
        border: "1px solid #007bff",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "10px",
        fontWeight: "bold",
    },
    delBtn: {
        position: "absolute",
        top: "-8px",
        right: "-8px",
        background: "#007bff",
        color: "#fff",
        borderRadius: "50%",
        width: "20px",
        height: "20px",
        textAlign: "center",
        lineHeight: "18px",
        fontSize: "14px",
        border: "1px solid #fff",
    },
    emptyMessage: { color: "black", fontSize: "12px" },
    // emptyMessage: { color: "#999", fontSize: "12px" },
    previewOverlay: {
        position: "fixed",
        inset: 0,
        backgroundColor: "#fff",
        zIndex: 11000,
        display: "flex",
        flexDirection: "column",
    },
    previewContent: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
    },
    fullImage: {
        maxWidth: "100%",
        maxHeight: "75vh",
        borderRadius: "8px",
        objectFit: "contain",
        border: "2px solid #007bff",
    },
    previewBottomNav: {
        height: "80px",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        padding: "0 15px",
        borderTop: "1px solid #eef2f7",
    },
    previewBackBtn: {
        padding: "12px 30px",
        backgroundColor: "#fff",
        color: "#007bff",
        border: "2px solid #007bff",
        borderRadius: "8px",
        fontWeight: "bold",
        fontSize: "14px",
    },
    previewRemoveBtn: {
        padding: "12px 30px",
        backgroundColor: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        fontWeight: "bold",
        fontSize: "14px",
    },
    pdfPreviewCard: {
        background: "#fff",
        padding: "40px",
        borderRadius: "15px",
        textAlign: "center",
        width: "80%",
        maxWidth: "300px",
    },
    pdfBadge: {
        marginTop: "10px",
        color: "#007bff",
        fontWeight: "bold",
        fontSize: "14px",
    },
    textAreaField: {
        width: "100%",
        minHeight: "80px",
        padding: "10px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        fontSize: "14px",
        fontFamily: "inherit",
        resize: "vertical",
        boxSizing: "border-box",
    },
    popupOverlay: {
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 12000,
    },
    popupBox: {
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "20px",
        maxWidth: "300px",
        textAlign: "center",
    },
    closePopupButton: {
        marginTop: "20px",
        width: "100%",
        padding: "12px",
        backgroundColor: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        fontWeight: "bold",
    },
    finalSubmit: {
        width: "40%",
        margin: "30px auto",
        display: "block",
        padding: "18px",
        color: "#fff",
        border: "none",
        borderRadius: "12px",
        fontWeight: "bold",
        fontSize: "16px",
    },
    cameraFull: {
        position: "fixed",
        inset: 0,
        backgroundColor: "#000",
        zIndex: 9999,
        display: "flex",
    },
    videoStream: { width: "100%", height: "100%", objectFit: "cover" },
    camControls: {
        position: "absolute",
        right: 0,
        top: 0,
        bottom: 0,
        width: "100px",
        backgroundColor: "rgba(0,0,0,0.7)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around",
    },
    shutterBtn: {
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(${cameraImg})`,
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        backgroundColor: "#929292",
        border: "7px solid #fff",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.25)",
    },
    doneBtn: {
        color: "#fff",
        background: "#007bff",
        border: "none",
        padding: "10px 20px",
        borderRadius: "8px",
    },
    countBadge: { color: "#fff", fontSize: "24px", fontWeight: "bold" },
};

export default NewDocumentUpload;
